module.exports = __webpack_public_path__ + "img/blog-7-3.c145474c.webp";